import type { ReactNode } from 'react'

/**
 * The dispatch pages' actions, as a second row of the sticky page header: in
 * view while scrolling a long list, and above the rows being ticked rather
 * than below them. Always rendered, so selecting the first item doesn't shift
 * the list; the fieldset disables every action until something is selected.
 */
export function SelectionBar({
  count,
  busy,
  hint,
  onClear,
  children,
}: {
  count: number
  busy: boolean
  /** Shown while nothing is selected. */
  hint: string
  onClear: () => void
  children: ReactNode
}) {
  return (
    <fieldset className="selection-bar" disabled={busy || count === 0}>
      <span className="count">{count ? `${count} selected` : <span className="hint">{hint}</span>}</span>
      {count ? (
        <button type="button" className="btn ghost sm" onClick={onClear}>
          Clear
        </button>
      ) : null}
      {children}
    </fieldset>
  )
}
